export interface FarmConfigParams {
  idFazenda: string
  ancpHabilitado?: boolean | null
  ancpNf?: string | null
  ancpAnimalMostrarProp?: string | null
  key?: string | null
  id?: string | null
  cloneAnimaisHabilitado?: boolean | null
  fichaNascimentoHabilitado?: boolean | null
  currentFarm?: string | null
  nomeAnimal?: string | null
  numeroBezerro?: string | null
  lote?: string | null
  local?: string | null
  rgn?: string | null
  rgd?: string | null
  inatividadeMax?: number | null
  escrotoHabilitado?: boolean | null
  desmamaIdade?: number | null
  desmamaPeso?: number | null
  smartCaptureEnabled?: boolean | null
}

export class FarmConfig implements FarmConfigParams {
  idFazenda: string
  ancpHabilitado: boolean | null
  ancpNf: string | null
  ancpAnimalMostrarProp: string | null
  key: string | null
  id: string | null
  cloneAnimaisHabilitado: boolean | null
  fichaNascimentoHabilitado: boolean | null
  currentFarm: string | null
  nomeAnimal: string | null
  numeroBezerro: string | null
  lote: string | null
  local: string | null
  rgn: string | null
  rgd: string | null
  inatividadeMax: number | null
  escrotoHabilitado: boolean | null
  desmamaIdade: number | null
  desmamaPeso: number | null
  smartCaptureEnabled: boolean | null

  constructor({
    idFazenda,
    ancpHabilitado = false,
    ancpNf = null,
    ancpAnimalMostrarProp = null,
    key = null,
    id = null,
    cloneAnimaisHabilitado = null,
    fichaNascimentoHabilitado = null,
    currentFarm = null,
    nomeAnimal = null,
    numeroBezerro = null,
    lote = null,
    local = null,
    rgn = null,
    rgd = null,
    inatividadeMax = null,
    escrotoHabilitado = true,
    desmamaIdade = null,
    desmamaPeso = null,
    smartCaptureEnabled = null
  }: FarmConfigParams) {
    this.idFazenda = idFazenda
    this.ancpHabilitado = ancpHabilitado
    this.ancpNf = ancpNf
    this.ancpAnimalMostrarProp = ancpAnimalMostrarProp
    this.key = key
    this.id = id
    this.cloneAnimaisHabilitado = cloneAnimaisHabilitado
    this.fichaNascimentoHabilitado = fichaNascimentoHabilitado
    this.currentFarm = currentFarm
    this.nomeAnimal = nomeAnimal
    this.numeroBezerro = numeroBezerro
    this.lote = lote
    this.local = local
    this.rgn = rgn
    this.rgd = rgd
    this.inatividadeMax = inatividadeMax
    this.escrotoHabilitado = escrotoHabilitado
    this.desmamaIdade = desmamaIdade
    this.desmamaPeso = desmamaPeso
    this.smartCaptureEnabled = smartCaptureEnabled
  }
}
